import React from 'react'
import styled from 'styled-components'

import { SvgIcon as MuiSvgIcon, SvgIconProps } from '@material-ui/core'

const SvgIcon = styled(MuiSvgIcon)`
  fill: unset;
`

// HOME
export const HomeIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L4.29289 11.7071C4.10536 11.8946 4 12.149 4 12.4142V19C4 19.5523 4.44772 20 5 20H8.71428C9.26657 20 9.71429 19.5523 9.71429 19V16.7333C9.71429 16.181 10.162 15.7333 10.7143 15.7333H13.2857C13.838 15.7333 14.2857 16.181 14.2857 16.7333V19C14.2857 19.5523 14.7334 20 15.2857 20H19C19.5523 20 20 19.5523 20 19V12.4142C20 12.149 19.8946 11.8946 19.7071 11.7071L12.7071 4.70711Z"
      fill="white"
      stroke="white"
      strokeWidth="1.5"
    />
  </SvgIcon>
))

export const HomeIconInactive: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7071 4.70711C12.3166 4.31658 11.6834 4.31658 11.2929 4.70711L4.29289 11.7071C4.10536 11.8946 4 12.149 4 12.4142V19C4 19.5523 4.44772 20 5 20H8.71428C9.26657 20 9.71429 19.5523 9.71429 19V16.7333C9.71429 16.181 10.162 15.7333 10.7143 15.7333H13.2857C13.838 15.7333 14.2857 16.181 14.2857 16.7333V19C14.2857 19.5523 14.7334 20 15.2857 20H19C19.5523 20 20 19.5523 20 19V12.4142C20 12.149 19.8946 11.8946 19.7071 11.7071L12.7071 4.70711Z"
        stroke="#7F7F7F"
        strokeWidth="1.5"
      />
    </g>
  </SvgIcon>
)

// MORE
export const MoreIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 14c1.10457 0 2-.8954 2-2s-.89543-2-2-2-2 .8954-2 2 .89543 2 2 2zM12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2zM18 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2z"
      fill="#fff"
    />
  </SvgIcon>
))

export const MoreIconInactive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon {...props}>
    <g stroke="#7F7F7F" strokeWidth="1.5">
      <circle cx="6" cy="12" r="1.25" />
      <circle cx="12" cy="12" r="1.25" />
      <circle cx="18" cy="12" r="1.25" />
    </g>
  </SvgIcon>
))

// GOALS
export const GoalsIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 9c0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8zm-6.1459-2.37902L12 3l-1.8541 3.62098L6 7.20163l3 2.81857L8.2918 14 12 12.121 15.7082 14 15 10.0202l3-2.81857-4.1459-.58065z"
      fill="#fff"
    />
    <path
      d="M12 3l.6676-.34183L12 1.35443l-.6676 1.30374L12 3zm1.8541 3.62098l-.6676.34182.1776.34687.386.05406.104-.74275zm-3.7082 0l.104.74275.386-.05406.1776-.34687-.6676-.34182zM6 7.20163l-.10403-.74275-1.55071.21718 1.1412 1.07217L6 7.20163zm3 2.81857l.7384.1314.07116-.39993-.29602-.27811L9 10.0202zM8.2918 14l-.7384-.1314-.26333 1.4798 1.34073-.6794-.339-.669zM12 12.121l.339-.669-.339-.1718-.339.1718.339.669zM15.7082 14l-.339.669 1.3407.6794-.2633-1.4798-.7384.1314zM15 10.0202l-.5135-.54664-.2961.27811.0712.39993.7384-.1314zm3-2.81857l.5135.5466 1.1412-1.07217-1.5507-.21718-.104.74275zM12 17.75c4.8325 0 8.75-3.9175 8.75-8.75h-1.5c0 4.0041-3.2459 7.25-7.25 7.25v1.5zM3.25 9c0 4.8325 3.91751 8.75 8.75 8.75v-1.5c-4.00406 0-7.25-3.2459-7.25-7.25h-1.5zM12 .25C7.16751.25 3.25 4.16751 3.25 9h1.5c0-4.00406 3.24594-7.25 7.25-7.25V.25zM20.75 9c0-4.83249-3.9175-8.75-8.75-8.75v1.5c4.0041 0 7.25 3.24594 7.25 7.25h1.5zm-9.4176-5.65817l1.8541 3.62097 1.3352-.68365-1.8541-3.62098-1.3352.68366zm-.5189 3.62097l1.8541-3.62097-1.3352-.68366-1.85408 3.62098 1.33518.68365zm-4.70947.98158l4.14587-.58065-.208-1.48551-4.14593.58066.20806 1.4855zm3.40951 1.52918l-3-2.81854-1.02708 1.09321 3 2.81857 1.02708-1.09324zM9.0302 14.1314l.7082-3.9798-1.4768-.26283-.7082 3.97983 1.4768.2628zm2.6308-2.6794l-3.70821 1.879.67801 1.338 3.7082-1.879-.678-1.338zm4.3862 1.879l-3.7082-1.879-.678 1.338 3.7082 1.879.678-1.338zm-1.7856-3.1794l.7082 3.9798 1.4768-.2628-.7082-3.97983-1.4768.26283zm3.2249-3.49658l-3 2.81854 1.027 1.09324 3-2.81857-1.027-1.09321zm-3.7364.70871l4.1459.58065.208-1.4855-4.1459-.58066-.208 1.48551z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25 17.8021V22c0 .2529.12741.4887.3389.6273.21148.1386.47857.1613.71042.0604l3.60088-1.5673c.0637-.0277.1359-.0277.1996 0l3.6009 1.5673c.2318.1009.4989.0782.7104-.0604.2115-.1386.3389-.3744.3389-.6273v-4.1979C15.337 18.5662 13.7192 19 12 19c-1.7192 0-3.33699-.4338-4.75-1.1979z"
      fill="#fff"
    />
  </SvgIcon>
))

export const GoalsIconInactive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon {...props}>
    <path
      d="M16 22l-.2993.6877c.2318.1009.4989.0782.7104-.0604.2115-.1386.3389-.3744.3389-.6273H16zm-8 0h-.75c0 .2529.12741.4887.3389.6273.21148.1386.47857.1613.71042.0604L8 22zm4.3991-1.5673l.2993-.6877-.2993.6877zm-.7982 0l.2993.6877-.2993-.6877zM15.25 16v6h1.5v-6h-1.5zm1.0493 5.3123l-3.6009-1.5673-.5986 1.3754 3.6009 1.5673.5986-1.3754zm-4.9977-1.5673l-3.60092 1.5673.59864 1.3754 3.60088-1.5673-.5986-1.3754zM8.75 22v-6h-1.5v6h1.5zm3.9484-2.255c-.4454-.1939-.9514-.1939-1.3968 0l.5986 1.3754c.0637-.0277.1359-.0277.1996 0l.5986-1.3754z"
      fill="#7F7F7F"
    />
    <circle cx="12" cy="9" r="8" stroke="#7F7F7F" strokeWidth="1.5" />
    <path
      clipRule="evenodd"
      d="M12 11.6334L9.52786 13 10 10.1056 8 8.05573l2.7639-.42229L12 5l1.2361 2.63344L16 8.05573l-2 2.04987L14.4721 13 12 11.6334z"
      stroke="#7F7F7F"
      strokeWidth="1.5"
    />
  </SvgIcon>
))

// PLANS
export const PlansIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <path
      d="M7.5001 3.91304v3.65218M16.6002 3.91304v3.65218"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7.34784c0-1.10457.89543-2 2-2h14c1.1046 0 2 .89543 2 2V19c0 1.1046-.8954 2-2 2H5c-1.10457 0-2-.8954-2-2V7.34784zm7.5671 2.25236l-3.24118 3.5074-1.97485-1.9233.69771-.7164 1.23943 1.2071 2.5445-2.75349.73439.67869zm7.9946 1.2585h-3.0368v1.5h3.0368v-1.5zm-7.5368 0h3.0368v1.5h-3.0368v-1.5zm-1.46316 3.913H6.5249v1.5h3.03684v-1.5zm1.46316 0h3.0368v1.5h-3.0368v-1.5zm7.5368 0h-3.0368v1.5h3.0368v-1.5z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7.34784c0-1.10457.89543-2 2-2h14c1.1046 0 2 .89543 2 2V19c0 1.1046-.8954 2-2 2H5c-1.10457 0-2-.8954-2-2V7.34784zm7.5671 2.25236l-3.24118 3.5074-1.97485-1.9233.69771-.7164 1.23943 1.2071 2.5445-2.75349.73439.67869zm7.9946 1.2585h-3.0368v1.5h3.0368v-1.5zm-7.5368 0h3.0368v1.5h-3.0368v-1.5zm-1.46316 3.913H6.5249v1.5h3.03684v-1.5zm1.46316 0h3.0368v1.5h-3.0368v-1.5zm7.5368 0h-3.0368v1.5h3.0368v-1.5z"
      fill="#fff"
    />
    <path
      d="M7.32592 13.1076l-1.04655 1.0746 1.10312 1.0743 1.04507-1.1309-1.10164-1.018zm3.24118-3.5074l1.1017 1.018 1.018-1.10161-1.1016-1.01803-1.0181 1.10164zm-5.21603 1.5841l-1.07458-1.0466-1.04655 1.0746 1.07458 1.0465 1.04655-1.0745zm.69771-.7164l1.04655-1.07461-1.07459-1.04655-1.04655 1.07458 1.07459 1.04658zm1.23943 1.2071l-1.04655 1.0746 1.10312 1.0743 1.04507-1.1309-1.10164-1.018zm2.5445-2.75349l1.01799-1.10164-1.1016-1.01803-1.01803 1.10164 1.10164 1.01803zm5.69219 1.93719v-1.5h-1.5v1.5h1.5zm3.0368 0h1.5v-1.5h-1.5v1.5zm-3.0368 1.5h-1.5v1.5h1.5v-1.5zm3.0368 0v1.5h1.5v-1.5h-1.5zm-4.5-1.5h1.5v-1.5h-1.5v1.5zm-3.0368 0v-1.5h-1.5v1.5h1.5zm3.0368 1.5v1.5h1.5v-1.5h-1.5zm-3.0368 0h-1.5v1.5h1.5v-1.5zm-4.5 2.413v-1.5h-1.5v1.5h1.5zm3.03684 0h1.49996v-1.5H9.56174v1.5zm-3.03684 1.5h-1.5v1.5h1.5v-1.5zm3.03684 0v1.5h1.49996v-1.5H9.56174zm4.49996-1.5h1.5v-1.5h-1.5v1.5zm-3.0368 0v-1.5h-1.5v1.5h1.5zm3.0368 1.5v1.5h1.5v-1.5h-1.5zm-3.0368 0h-1.5v1.5h1.5v-1.5zm4.5-1.5v-1.5h-1.5v1.5h1.5zm3.0368 0h1.5v-1.5h-1.5v1.5zm-3.0368 1.5h-1.5v1.5h1.5v-1.5zm3.0368 0v1.5h1.5v-1.5h-1.5zM5 3.84784c-1.933 0-3.5 1.56701-3.5 3.5h3c0-.27614.22386-.5.5-.5v-3zm14 0H5v3h14v-3zm3.5 3.5c0-1.933-1.567-3.5-3.5-3.5v3c.2761 0 .5.22386.5.5h3zM22.5 19V7.34784h-3V19h3zM19 22.5c1.933 0 3.5-1.567 3.5-3.5h-3c0 .2762-.2239.5-.5.5v3zm-14 0h14v-3H5v3zM1.5 19c0 1.933 1.567 3.5 3.5 3.5v-3c-.27614 0-.5-.2238-.5-.5h-3zm0-11.65216V19h3V7.34784h-3zm6.92756 6.77776l3.24124-3.5074-2.2033-2.03604-3.24121 3.50744 2.20327 2.036zm-4.12304-1.8668l1.97485 1.9234 2.09311-2.1492-1.97485-1.9233-2.09311 2.1491zm.66967-2.83748l-.6977.71638 2.14917 2.0931.6977-.7164-2.14917-2.09308zm3.36057 1.17908L7.09533 9.39329 5.00222 11.5425l1.23944 1.2071 2.0931-2.1492zm.39631-2.69692l-2.5445 2.75342 2.20328 2.0361 2.54455-2.75346-2.20333-2.03606zm2.85413.59508l-.7345-.67869-2.03602 2.20323.73443.6787 2.03609-2.20324zm3.9397 3.86014h3.0368v-3h-3.0368v3zm1.5 0v-1.5h-3v1.5h3zm1.5368-1.5h-3.0368v3h3.0368v-3zm-1.5 0v1.5h3v-1.5h-3zm-3-1.5h-3.0368v3h3.0368v-3zm1.5 3v-1.5h-3v1.5h3zm-4.5368 1.5h3.0368v-3h-3.0368v3zm-1.5-3v1.5h3v-1.5h-3zm-3 5.413h3.03684v-3H6.5249v3zm1.5 0v-1.5h-3v1.5h3zm1.53684-1.5H6.5249v3h3.03684v-3zm-1.5 0v1.5h2.99996v-1.5H8.06174zm5.99996-1.5h-3.0368v3h3.0368v-3zm1.5 3v-1.5h-3v1.5h3zm-4.5368 1.5h3.0368v-3h-3.0368v3zm-1.5-3v1.5h3v-1.5h-3zm6 1.5h3.0368v-3h-3.0368v3zm1.5 0v-1.5h-3v1.5h3zm1.5368-1.5h-3.0368v3h3.0368v-3zm-1.5 0v1.5h3v-1.5h-3z"
      fill="#fff"
      mask="url(#a)"
    />
  </SvgIcon>
))

export const PlansIconInactive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <g stroke="#7F7F7F">
      <rect
        x="3.75"
        y="6.09784"
        width="16.5"
        height="14.1522"
        rx="1.25"
        strokeWidth="1.5"
      />
      <path
        d="M7.5001 3.91304v3.65218M16.6002 3.91304v3.65218"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M5.69995 10.8261l1.60714 1.5652L10.2 9.26086" />
      <path
        d="M16.2751 11.6087h1.5368M11.7751 11.6087h1.5368M7.2751 15.5217h1.53683M11.7751 15.5217h1.5368M16.2751 15.5217h1.5368"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </g>
  </SvgIcon>
))

// PROFILE
export const ProfileIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 17.5c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-.739c0-.1309-.0499-.2552-.1459-.3442-.5752-.5334-2.7807-2.4089-5.3541-2.4089s-4.77889 1.8755-5.3541 2.4089c-.096.089-.1459.2133-.1459.3442v.739z"
      fill="#fff"
    />
    <ellipse cx="7.3" cy="9.5" rx="2.3" ry="2.5" fill="#fff" />
    <path
      d="M22 15.261V16c0 .2761-.2239.5-.5.5H12l-1-1.4432s2.5-2.5489 5.5-2.5489c2.5734 0 4.7789 1.8755 5.3541 2.4089.096.089.1459.2133.1459.3442z"
      fill="#fff"
    />
    <ellipse cx="16.3" cy="8" rx="2.3" ry="2.5" fill="#fff" />
  </SvgIcon>
))

export const ProfileIconInactive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <path
      d="M2 18h-.75c0 .4142.33579.75.75.75V18zm11 0v.75c.4142 0 .75-.3358.75-.75H13zm0-1.4432h.75c0-.1964-.077-.385-.2146-.5252L13 16.5568zm-11 0l-.53544-.5252c-.13752.1402-.21456.3288-.21456.5252H2zM2 18.75h11v-1.5H2v1.5zM13.75 18v-1.4432h-1.5V18h1.5zM13 16.5568c.5354-.5252.5353-.5254.5351-.5256-.0001 0-.0002-.0002-.0004-.0004-.0003-.0002-.0006-.0006-.001-.0009-.0007-.0008-.0015-.0016-.0026-.0027-.002-.0021-.0047-.0047-.008-.008-.0065-.0066-.0155-.0155-.0269-.0266-.0227-.0223-.0549-.0534-.0961-.0921-.0823-.0773-.201-.1853-.352-.3136-.3013-.256-.7352-.5963-1.2701-.9371-1.0564-.6732-2.57466-1.3919-4.278-1.3919v1.5c1.29666 0 2.5284.5557 3.472 1.1569.4651.2964.8437.5934 1.1049.8153.1302.1106.2303.2018.2964.2639.033.031.0575.0546.0729.0697.0076.0075.0131.0129.0162.016.0015.0016.0025.0025.0028.0029.0002.0002.0003.0002.0001.0001 0 0-.0001-.0001-.0002-.0003-.0001 0-.0002-.0001-.0003-.0002-.0001-.0001-.0002-.0003.5352-.5254zm-5.5-3.2989c-1.70334 0-3.22162.7187-4.27804 1.3919-.53487.3408-.96875.6811-1.27007.9371-.15101.1283-.26966.2363-.35202.3136-.04121.0387-.0734.0698-.0961.0921-.01135.0111-.02034.02-.02689.0266-.00328.0033-.00595.0059-.008.008-.00103.0011-.0019.0019-.00262.0027-.00036.0003-.00069.0007-.00097.0009-.00014.0002-.00032.0004-.00039.0004-.00018.0002-.00034.0004.5351.5256.53544.5251.5353.5253.53516.5254-.00003.0001-.00016.0002-.00022.0002-.00013.0002-.00023.0003-.00028.0003-.00011.0001-.00008.0001.00011-.0001.00037-.0004.00133-.0013.00288-.0029.00309-.0031.00851-.0085.0162-.016.01539-.0151.03983-.0387.07284-.0697.06608-.0621.16618-.1533.29642-.2639.26118-.2219.6398-.5189 1.10493-.8153.94358-.6012 2.1753-1.1569 3.47196-1.1569v-1.5zm-6.25 3.2989V18h1.5v-1.4432h-1.5z"
      fill="#7F7F7F"
    />
    <ellipse
      cx="7.3"
      cy="9.5"
      rx="2.3"
      ry="2.5"
      stroke="#7F7F7F"
      strokeWidth="1.5"
    />
    <path
      d="M22 16.5v.75c.4142 0 .75-.3358.75-.75H22zm0-1.4432h.75c0-.1964-.077-.385-.2146-.5252L22 15.0568zm.75 1.4432v-1.4432h-1.5V16.5h1.5zM22 15.0568c.5354-.5252.5353-.5254.5351-.5256-.0001 0-.0002-.0002-.0004-.0004-.0003-.0002-.0006-.0006-.001-.0009-.0007-.0008-.0015-.0016-.0026-.0027-.002-.0021-.0047-.0047-.008-.008-.0065-.0066-.0155-.0155-.0269-.0266-.0227-.0223-.0549-.0534-.0961-.0921-.0823-.0773-.201-.1853-.352-.3136-.3013-.256-.7352-.5963-1.2701-.9371-1.0564-.6732-2.5747-1.3919-4.278-1.3919v1.5c1.2967 0 2.5284.5557 3.472 1.1569.4651.2964.8437.5934 1.1049.8153.1302.1106.2303.2018.2964.2639.033.031.0575.0546.0729.0697.0076.0075.0131.0129.0162.016.0015.0016.0025.0025.0028.0029.0002.0002.0003.0002.0001.0001 0 0-.0001-.0001-.0002-.0003-.0001 0-.0002-.0001-.0003-.0002-.0001-.0001-.0002-.0003.5352-.5254zm-5.5-3.2989c-1.7033 0-3.2216.7187-4.278 1.3919-.5349.3408-.9688.6811-1.2701.9371-.151.1283-.2697.2363-.352.3136-.0412.0387-.0734.0698-.0961.0921-.0114.0111-.0204.02-.0269.0266-.0033.0033-.006.0059-.008.008-.0011.0011-.0019.0019-.0026.0027-.0004.0003-.0007.0007-.001.0009-.0001.0002-.0003.0004-.0004.0004-.0002.0002-.0003.0004.5351.5256.5354.5251.5353.5253.5352.5254-.0001.0001-.0002.0002-.0003.0002-.0001.0002-.0002.0003-.0002.0003-.0002.0001-.0001.0001.0001-.0001.0003-.0004.0013-.0013.0028-.0029.0031-.0031.0086-.0085.0162-.016.0154-.0151.0399-.0387.0729-.0697.0661-.0621.1662-.1533.2964-.2639.2612-.2219.6398-.5189 1.1049-.8153.9436-.6012 2.1753-1.1569 3.472-1.1569v-1.5zM13 17.25h9v-1.5h-9v1.5z"
      fill="#7F7F7F"
    />
    <ellipse
      cx="16.3"
      cy="8"
      rx="2.3"
      ry="2.5"
      stroke="#7F7F7F"
      strokeWidth="1.5"
    />
  </SvgIcon>
))

// RELEASES
export const ReleasesIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <circle cx="7" cy="17" r="2.25" stroke="#fff" strokeWidth="1.5" />
    <circle cx="17" cy="15" r="2.25" stroke="#fff" strokeWidth="1.5" />
    <path d="M9.25 17V5l10-2.5V15" stroke="#fff" strokeWidth="1.5" />
    <path
      d="M19.25 5.5L9.25 8V5.5l10-2.3815V5.5z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="1.5"
    />
    <path stroke="#fff" strokeWidth="1.5" d="M4 22.25h16" />
  </SvgIcon>
))

export const ReleasesIconInactive: React.FC<SvgIconProps> = React.memo(
  props => (
    <SvgIcon fill="none" {...props}>
      <circle cx="17" cy="15" r="2.25" stroke="#7F7F7F" strokeWidth="1.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.58565V17c0 1.6569-1.34315 3-3 3s-3-1.3431-3-3c0-1.6568 1.34315-3 3-3 .54643 0 1.05874.1461 1.5.4014V4.41443l11.5-2.875V15l-1.5-2V6.46065l-8.5 2.125zm0-1.54616l8.5-2.125v-1.4539l-8.5 2.125v1.4539zM7 18.5c.82843 0 1.5-.6716 1.5-1.5s-.67157-1.5-1.5-1.5-1.5.6716-1.5 1.5.67157 1.5 1.5 1.5z"
        fill="#7F7F7F"
      />
      <path stroke="#7F7F7F" strokeWidth="1.5" d="M4 22.25h16" />
    </SvgIcon>
  )
)

// ManageMyPartnership

export const ManageMyPartnershipIconActive: React.FC<SvgIconProps> = React.memo(
  props => (
    <SvgIcon fill="none" {...props}>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 13v.75h.53l.177-.5L5.5 13zm3-8.5l.705-.256-.716-1.968-.696 1.974.707.25zm4 11l-.705.256.64 1.762.752-1.717-.687-.301zm3.5-8l.705-.256-.64-1.762-.752 1.717L16 7.5zm2 5.5l-.705.256.18.494H18V13zm-16 .75h3.5v-1.5H2v1.5zm4.207-.5l3-8.5-1.414-.5-3 8.5 1.414.5zm1.588-8.494l4 11 1.41-.512-4-11-1.41.512zm5.392 11.045l3.5-8-1.374-.602-3.5 8 1.374.602zm2.108-8.045l2 5.5 1.41-.512-2-5.5-1.41.512zM18 13.75h3v-1.5h-3v1.5z"
          fill="#fff"
        />
      </svg>
    </SvgIcon>
  )
)

export const ManageMyPartnershipIconInactive: React.FC<SvgIconProps> =
  React.memo(props => (
    <SvgIcon fill="none" {...props}>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.5 13v.75h.53l.177-.5L5.5 13zm3-8.5l.705-.256-.716-1.968-.696 1.974.707.25zm4 11l-.705.256.64 1.762.752-1.717-.687-.301zm3.5-8l.705-.256-.64-1.762-.752 1.717L16 7.5zm2 5.5l-.705.256.18.494H18V13zm-16 .75h3.5v-1.5H2v1.5zm4.207-.5l3-8.5-1.414-.5-3 8.5 1.414.5zm1.588-8.494l4 11 1.41-.512-4-11-1.41.512zm5.392 11.045l3.5-8-1.374-.602-3.5 8 1.374.602zm2.108-8.045l2 5.5 1.41-.512-2-5.5-1.41.512zM18 13.75h3v-1.5h-3v1.5z"
          fill="#7F7F7F"
        />
      </svg>
    </SvgIcon>
  ))

// TRAINER

export const TrainerIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" fillOpacity=".01" d="M0 0h24v24H0z" />
      <path
        stroke="#fff"
        strokeWidth="1.5"
        d="M4.75 8.75h2.5v6.5h-2.5zM16.75 8.75h2.5v6.5h-2.5z"
      />
      <path
        d="M21.667 9.833v4.61M2.333 9.833v4.61M8.333 12h8"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  </SvgIcon>
))

export const TrainerIconInactive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#7F7F7F" fillOpacity=".01" d="M0 0h24v24H0z" />
      <path
        stroke="#7F7F7F"
        strokeWidth="1.5"
        d="M4.75 8.75h2.5v6.5h-2.5zM16.75 8.75h2.5v6.5h-2.5z"
      />
      <path
        d="M21.667 9.833v4.61M2.333 9.833v4.61M8.333 12h8"
        stroke="#7F7F7F"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  </SvgIcon>
))

// AssessorS

export const AssessorIconActive: React.FC<SvgIconProps> = React.memo(props => (
  <SvgIcon fill="none" {...props}>
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="3.75"
        y="2.75"
        width="16.5"
        height="18.5"
        rx="1.25"
        stroke="#fff"
        strokeWidth="1.5"
      />
      <path
        d="M8 10.565l2.634 2.565L15.375 8"
        stroke="#fff"
        strokeWidth="1.639"
      />
      <path
        d="M7.75 16.783h8.538"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  </SvgIcon>
))

export const AssessorIconInactive: React.FC<SvgIconProps> = React.memo(
  props => (
    <SvgIcon fill="none" {...props}>
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.75"
          y="2.75"
          width="16.5"
          height="18.5"
          rx="1.25"
          stroke="#7F7F7F"
          strokeWidth="1.5"
        />
        <path
          d="M8 10.565l2.634 2.565L15.375 8"
          stroke="#7F7F7F"
          strokeWidth="1.639"
        />
        <path
          d="M7.75 16.783h8.538"
          stroke="#7F7F7F"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </svg>
    </SvgIcon>
  )
)
